/**
 * CustomersListRoute — skin-aware switcher for /customers.
 * Cockpit → wraps classic CustomersList in .cockpit-surface (CSS-scoped restraint).
 */
import { useUISkin } from "@/data/UISkinContext";
import { CUSTOMERS_SERVER_PAGING_ENABLED } from "@/lib/dataRuntimeFlags";
import { isCustomersServerPagedRoute, useBrowserLocationSnapshot } from "@/lib/routeScope";
import CustomersList from "./CustomersList";
import CustomersListCockpit from "./CustomersListCockpit";
import CustomersListServer from "./CustomersListServer";
import CustomersListCockpitServer from "./CustomersListCockpitServer";

export default function CustomersListRoute() {
  const { skin } = useUISkin();
  const location = useBrowserLocationSnapshot();
  const useServerPaging =
    CUSTOMERS_SERVER_PAGING_ENABLED &&
    isCustomersServerPagedRoute(location.pathname);

  if (skin === "cockpit") {
    return useServerPaging ? <CustomersListCockpitServer /> : <CustomersListCockpit />;
  }
  if (useServerPaging) return <CustomersListServer />;
  return <CustomersList />;
}
